module.exports = __webpack_public_path__ + "static/img/EyoOs.47ad1a69.gif";